import {Worker} from "../util";

export default class PoziadavkaBaseCtrl {

  static $inject = ["PoziadavkaService", "$stateParams", "PoznamkaEditModal", "PoziadavkaCloseModal", "PoziadavkaReopenModal"];

  constructor(PoziadavkaService, $stateParams, PoznamkaEditModal, PoziadavkaCloseModal, PoziadavkaReopenModal) {
    this.PoziadavkaService = PoziadavkaService;
    this.PoznamkaEditModal = PoznamkaEditModal;
    this.PoziadavkaCloseModal = PoziadavkaCloseModal;
    this.PoziadavkaReopenModal = PoziadavkaReopenModal;
    this.loadPoziadavka = Worker(this._loadPoziadavka);
    this.poziadavkaId = $stateParams.id;
    this.loadPoziadavka();
  }

  _loadPoziadavka() {
    return this.PoziadavkaService.get(this.poziadavkaId).then(poziadavka => this.poziadavka = poziadavka);
  }

  showPoziadavka(poziadavka) {
    this.poziadavka = poziadavka;
    if(this.poziadavkaId !== this.poziadavka.id){
      this.$state.go(this.$state.current.name, {id: this.poziadavka.id});
    }
  }

  closePoziadavka() {
    this.PoziadavkaCloseModal({id: this.poziadavka.id})
      .result
      .then(poziadavka => {
        this.PoziadavkaService.close(poziadavka).then(poziadavka => this.poziadavka = poziadavka);
      });
  }

  reopenPoziadavka() {
    this.PoziadavkaReopenModal({})
      .result
      .then(result => {
         this.PoziadavkaService.addPoznamka(
           {
             poziadavka: {
               id: this.poziadavka.id
             },
             externa: true,
             text: 'Požiadavka bola znovu otvorená, dôvod: ' + result.dovod
           }
         ).then(() => this.loadPoziadavka());
      });
      
  }

  addPoznamka(){
    this.PoznamkaEditModal({
      id: this.poziadavka.id,
      zodpovedny: this.poziadavka.zodpovedny,
      replyTo: this.poziadavka.replyTo
    })
    .result
    .then((result) => {
      this.PoziadavkaService.addPoznamka(result.poznamka)
      .then(poznamka => {
        this.loadPoziadavka();
      }, GlobalErrorHandler);
    });
  }

}


// WEBPACK FOOTER //
// ./src/poziadavky/PoziadavkaBaseCtrl.js